<template>
    <div :class="$style['popup-content-container']">
        <div :class="$style['popup-content-container-inner']">
            <template v-if="errorMessage != null">
                {{ errorMessage }}
            </template>
            <template v-else>
                <div
                    v-if="step === 0"
                    :class="[
                        $style['step-content'],
                        $style['step-content-intro-container'],
                    ]"
                >
                    <div>
                        <strong :class="$style['step-content-header']">{{
                            labels.frontendProductpage.savedCard.popup.header
                        }}</strong>
                        <div :class="$style['step-content-intro']">
                            <div
                                v-html="
                                    labels.frontendProductpage.savedCard.popup
                                        .content
                                "
                                :class="$style['step-content-content']"
                            ></div>
                            <br />
                            <cool-button
                                :busy="loading || firstFrameLoadResult != null"
                            >
                                <button @click="goToStep1()">
                                    {{
                                        labels.frontendProductpage.savedCard
                                            .next
                                    }}
                                </button>
                            </cool-button>
                            <br />
                            <div>
                                {{
                                    labels.frontendProductpage.savedCard.popup
                                        .contentAfterButton
                                }}
                                <a
                                    :href="termsLink"
                                    target="_blank"
                                    :class="$style['terms-link']"
                                    >{{
                                        labels.frontendProductpage.savedCard
                                            .popup.termsLinkText
                                    }}</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="step === 1 || iframeUrl != null"
                    v-show="step === 1"
                    :class="$style['step-content']"
                >
                    <iframe
                        :src="iframeUrl"
                        ref="iframe"
                        :class="$style['modal-form-iframe']"
                        @load="iframeLoad"
                    ></iframe>
                </div>
                <div v-if="step === 2" :class="$style['step-content']">
                    <template v-if="waitingForAccept">
                        <wait></wait>
                        <span v-for="n in waitAttempts" :data-attempt="n"
                            >.</span
                        >
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<style module lang="scss">
@import "common.css.src/mixins.scss";

.card-management-page {
}

.cover-spinner {
    margin-left: 50%;
    margin-top: 50%;
    transform: translate(-50%, -50%);
}

.modal-dialog {
    max-height: 95svh;
    @include when-desktop() {
        max-height: 85svh;
        max-width: 1024px;
    }
}

.modal-dialog {
    background-color: white;
    color: black;
    width: 95%;
    top: 50svh;
    left: 50vw;
    transform: translate(-50%, -50%);
    height: 100svh;
    position: fixed;
}

.modal-form-iframe {
    width: 100%;
    height: 100%;
    min-height: 640px;
}

.terms-link {
    text-decoration: underline;
}

.modal-form-iframe {
    @include when-desktop() {
        min-width: 750px;
    }
}

.popup-content-container {
    height: 100%;
    /*background-color: white;
        position: absolute;
        color: black;
        width: 80%;
        max-height: 85svh;
        top: 50vh;
        left: 50vw;
        transform: translate(-50%,-50%);
        height: 100svh;*/
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    background: white;
    border: 1px solid black;

    max-height: 95svh;
    overflow-y: scroll;

    @include when-desktop() {
        max-height: unset;
        overflow-y: unset;
    }
}

.step-content {
    height: 100%;
}

.popup-content-container-inner {
    height: 100%;
}

.modal-form-cover-load {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
    font-size: 46px;
}

.card-items {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.card-item {
    display: inline-block;
    border-radius: 5px;
    border: 1px solid black;
}

.card-item.card-valid {
    background-color: #c2e0b8;
}

.card-item.card-invalid {
    background-color: #e0b8b8;
}

.issued-to-container {
    display: block;
}

.card-number-container {
    display: block;
}

.step-content-intro {
    text-align: center;
}

.step-content-content {
    white-space: pre-line;
    text-align: center;
}

.step-content-content {
    @include when-desktop() {
        max-width: 380px;
    }
}

.step-content-header {
    font-size: 1.5em;
    text-align: center;
    display: block;
    text-transform: uppercase;
    font-weight: 900;
    margin-bottom: 20px;
}

.step-content-intro-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 30px;
    font-size: 0.95rem;
    @include when-desktop() {
        font-size: unset;
    }
}
</style>

<script>
import CoolButton from "../../../shared/CoolButton.vue";
import labels from "../../../shared/labels.ts";
import { createCard, linkCardFrame, checkCardAccepted } from "../web-api";

import wait from "./wait.vue";

export default {
    components: {
        wait,
        CoolButton: CoolButton,
    },
    props: {
        termsLink: String,
    },
    data() {
        return {
            step: 0,
            waitingForAccept: false,
            waitForAcceptOnCardId: null,
            gotAccept: false,
            iframeUrl: null,
            loading: false,
            waitAttempts: 0,
            errorMessage: null,
            firstFrameLoadResult: null,
        };
    },
    computed: {
        labels() {
            return labels;
        },
    },
    methods: {
        async iframeLoad() {
            if (this.firstFrameLoadResult != null) {
                this.firstFrameLoadResult.res();
                this.firstFrameLoadResult = null;
                return;
            }
            //console.debug("LOAD FRAME", arguments);
            const frame = this.$refs.iframe;
            if (frame.contentDocument != null && frame.contentWindow != null) {
                if (frame.contentWindow.hasOwnProperty("postBackResult")) {
                    const result = frame.contentWindow.postBackResult;
                    if (result.success === true) {
                        // console.debug("Result succeeded. Waiting for reply.");
                        this.waitForAcceptOnCardId = result.waitForAcceptOnCard;
                        this.iframeUrl = null;
                        await this.tryWaitAccept();
                    } else {
                        // TODO what now?
                        // console.debug("Result did not succeed");
                        this.$emit("cancelled");
                    }
                } else {
                    // console.debug("Frame has no result");
                }
            } else {
                // console.debug("Not available frame");
            }
        },
        handleError(data) {
            if (data.forceLogIn) {
                alert("Not logged in");
            }
            alert(data.message);
            const err = new Error(data.message);
            this.errorMessage = data.message;
            throw err;
        },
        async goToStep1() {
            if (this.loading === true) return;
            this.loading = true;
            this.iframeUrl = null;
            try {
                const createCardResponse = await createCard();
                const createCardData = createCardResponse.data;
                if (createCardData.success !== true) {
                    this.handleError(createCardData);
                    return;
                }

                const linkCardResponse = await linkCardFrame(
                    createCardData.cardId
                );
                const linkCardData = linkCardResponse.data;
                if (linkCardData.success !== true) {
                    this.handleError(linkCardData);
                    return;
                }

                const frameLoad = this.firstFrameLoad();
                this.iframeUrl = linkCardData.url;
                await frameLoad;
                this.step = 1;
            } finally {
                this.loading = false;
            }
        },
        async firstFrameLoad() {
            return new Promise((res, rej) => {
                this.firstFrameLoadResult = { res, rej };
            });
        },
        async tryWaitAccept() {
            this.step = 2;
            this.waitAttempts = 0;
            this.waitingForAccept = true;
            for (let i = 0; i < 10; i++) {
                const response = await checkCardAccepted(
                    this.waitForAcceptOnCardId
                );
                const data = response.data;
                if (data.success !== true) {
                    this.handleError(data);
                    return;
                }
                if (data.accepted === true) {
                    this.waitingForAccept = false;
                    this.gotAccept = true;
                    this.$emit("card-accepted");
                    return true;
                }
                this.waitAttempts++;
                await this.wait(2000);
            }
            this.$emit("card-failed-accept");
            return false;
        },
        async wait(ms) {
            return new Promise((res) => {
                setTimeout(() => {
                    res();
                }, ms);
            });
        },
    },
};
</script>
